import GentleWidget from '../common/widget';
import GentleComponentBubble from './bubble';

// 버튼
var GentleComponentQuickReply = Object.create( GentleWidget );
GentleComponentQuickReply.createComponent = function(buttons){
    /**
     button : {
         title:
         onClick:
         send:  // 디폴트 true
     }
     */
    // 컨테이너 생성후 자식요소 삽입 
    var $buttonContainer = $('<div class="gentle-quickreply-group"></div>');

    for( let i=0; i<buttons.length; i++ ){
        const option = buttons[i];

        if(option.title === undefined) throw new Error('버튼텍스트는 필수요소입니다');

        const html = `
        <button>${option.title}</button>
        `;
        const $button = $(html);
        
        if(option.onDisableAfterClick !== false){
            $button.bind('click', function(){
                // $button.attr('disabled',true);
                $(this).closest(".button-container").find("button").attr('disabled',true);
            });
        }

        const send = option.send === false ? false : true;

        const {text} = option;
        if(text){  // 송신값을 지정한 경우
            $button.bind('click', function(){
                GentleComponentBubble.insertUserBubble({html:text, send})
            });
        }

        // 커스텀 핸들러
        if(option.onClick !== undefined){
            $button.bind('click', option.onClick);
        }

        $buttonContainer.append( $button );
    }
    
    this.setPrefix('quickReply');
    this.init( $buttonContainer );
}


export default GentleComponentQuickReply;